<h2 class="step-title">{{ title }}</h2>
<h3>{{ subtitle }}</h3>
<div class="field">
  <div class="control">
    <input class="input is-large reverse-age-input" type="text" inputmode="numeric" maxlength="3" placeholder="Age"
      [ngClass]="{'is-danger': highlightingBoxForRequiredInfo && control.touched && control.errors}"
      formControlName="title_holder_age" #age (input)="ageChanged()" autocomplete="off" name="title_holder_age">
  </div>
  @if (control.touched && control.errors) {
    <div class="help is-danger has-text-left">
      <p>Enter an age, for example 70.</p>
    </div>
  }
</div>

@if (tooYoung) {
  <div class="reverse-stop" role="status">
    <p class="reverse-stop-title">Reverse mortgages are for homeowners 62 and older</p>
    <p>You may still have other ways to use your home's equity, such as a cash-out refinance or a home equity loan.</p>
    <a class="button is-large has-shadow-small" href="/communication/form-landing?type=home-equity-loan">See home equity options</a>
  </div>
} @else {
  <button class="button continue is-large has-shadow-small" (click)="submit()">
    Continue
    <i class="fas fa-chevron-right"></i>
  </button>
}
